/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicLinkDto } from '../../models/public-link-dto';

export interface LinksPublicControllerFindAllActive$Params {
}

export function linksPublicControllerFindAllActive(http: HttpClient, rootUrl: string, params?: LinksPublicControllerFindAllActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicLinkDto>>> {
  const rb = new RequestBuilder(rootUrl, linksPublicControllerFindAllActive.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicLinkDto>>;
    })
  );
}

linksPublicControllerFindAllActive.PATH = '/links/public';
